module.exports = __webpack_public_path__ + "77e7d104becfb126ca88da899aae9ccb.png";